import { joinStrings } from "@hex-insights/core";
import { User, UserNameFragment, UserNameOrder, UserPublicNameFormat } from "../../../Utilities";
import * as Fields from "./fields";

export { Fields };

export type NameOptions = {
	ignoreCurrent?: boolean;
	ignorePublicName?: boolean;
};

/**
 * Formats the full name of the given instance.
 */
export function name(instance: UserNameFragment, { ignoreCurrent, ignorePublicName }: NameOptions = {}) {
	if (!ignoreCurrent && instance.isCurrent) {
		return "You";
	}
	if (instance.givenName === "" && instance.familyName === "") {
		return `User#${instance.id}`;
	}
	if (!ignorePublicName) {
		return Fields.publicName(instance.publicName);
	}
	return Fields.name(instance.name);
}

export function nameFromFields(
	instance: Pick<User, "givenName" | "familyName"> & { nameOrder: User["nameOrder"] | null },
) {
	if (instance.nameOrder === UserNameOrder.FamilyGiven) {
		return instance.familyName + " " + instance.givenName;
	}
	return instance.givenName + " " + instance.familyName;
}

export function publicNameFromFields(
	instance: Pick<User, "givenName" | "familyName"> & {
		nameOrder: User["nameOrder"] | null;
		publicNameFormat: User["publicNameFormat"] | null;
	},
) {
	let givenDisplay = "";
	let familyDisplay = "";
	switch (instance.publicNameFormat) {
		case null:
		case UserPublicNameFormat.FullName:
			givenDisplay = instance.givenName;
			familyDisplay = instance.familyName;
			break;
		case UserPublicNameFormat.GivenNameFamilyInitial:
			givenDisplay = instance.givenName;
			familyDisplay = instance.familyName.charAt(0);
			break;
		case UserPublicNameFormat.Hidden:
			return "Anonymous";
	}

	if (instance.nameOrder === UserNameOrder.FamilyGiven) {
		return joinStrings([familyDisplay, givenDisplay], ", ");
	}

	return joinStrings([givenDisplay, familyDisplay], " ");
}
